import PropTypes from 'prop-types'
import { truncate } from 'utils/strings'
import MarkedText from 'components/Shared/MarkedText/Index'

const PartnersList = ({ partnerIds, defaultValue, markedPart }) => {
  let result

  if (partnerIds && partnerIds.map) {
    result = partnerIds.map(id =>
      <div key={id}>
        <MarkedText text={truncate(id, 32)} markedPart={markedPart} />
      </div>
    )
  } else {
    result = partnerIds ? truncate(partnerIds, 32) : defaultValue
  }

  return result
}

PartnersList.propTypes = {
  partnerIds: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  defaultValue: PropTypes.string,
  markedPart: PropTypes.string,
}

export default PartnersList
